export const TEXT_TABLE = {
    no: "ลำดับ",
    cardid_vat: "เลขที่ประจำตัวผู้เสียภาษี",
    no_branch: "ลำดับสาขา",
    company_name: "ชื่อบริษัท / บุคคล",
    address: "ที่อยู่",
    actionNext: "ดำเนินการ",
    action:"Action",
    receiptNo:"เลขที่เอกสาร",
    receiptNumber:"เลขที่ใบเสร็จ",
    tpno:"เลข TPNo.",
    qty:"จำนวนชิ้น",
    totalAmtExdiscount:"มูลค่าสินค้ารวมภาษี",
    taxValue:"ภาษีมูลค่าเพิ่ม",
    totalVatItemAmt:"มูลค่าสินค้าไม่รวมภาษี",
    totalDiscount:"ส่วนลด",
    delete:"ลบ",
    taxinvoiceNo:"เลขที่ใบกำกับภาษี",
    email:"E-Mail",
    status: "สถานะ"
}